import React from 'react';

const ItineraryTable = ({
    disabled,
    handleitinerary,
    itinerarybtntext,
    ClearItineraryDetail,
    dataitinerary,
    dataitinerarycounter,
    handleEditItinerary,
    removeitinerary
}) => {
    return (
        <>
            <div className="d-flex justify-content-center mt-3 bg-body">
                <button
                    type="button"
                    className="btn btn-primary mx-1"
                    id="btnAdd"
                    disabled={disabled}
                    onClick={handleitinerary}
                >
                    {itinerarybtntext}
                </button>
                <button
                    type="button"
                    className="btn btn-primary mx-1"
                    id="btnClear"
                    disabled={disabled}
                    onClick={ClearItineraryDetail}
                >
                    Clear
                </button>
            </div>

            <div className="col-12">
                <div className="my-3 row form_border py-3">
                    <div className="col-lg-12 mb-1 table-scrollable">
                        <table id="data" className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th className="text-end pe-4">Edit</th>
                                    <th className="text-end pe-4">Remove</th>
                                </tr>
                            </thead>
                            <tbody id="location-data">
                                {dataitinerarycounter > 0 && dataitinerary?.map((element) => (
                                    <tr className="ReactTable" key={element.SeqNo}>
                                        <td>{element.Day}</td>
                                        <td className="text-end">
                                            <button
                                                type="button"
                                                onClick={(e) => handleEditItinerary(element.SeqNo, e)}
                                                className="btn btn-primary mx-1"
                                                id="btnEdit"
                                                disabled={disabled}
                                            >
                                                Edit
                                            </button>
                                        </td>
                                        <td className="text-end">
                                            <button
                                                type="button"
                                                onClick={(e) => removeitinerary(element.SeqNo, e)}
                                                className="btn btn-primary mx-1"
                                                id="btnAdd"
                                                disabled={disabled}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default React.memo(ItineraryTable);

